import React from 'react';

const OtherProvidersSection = () => {
  // Providers data
  const providers = [
  {
    id: 1,
    name: 'Azure',
    logo: '../assets/images/migration/azure-logo-128e2443446487b0e0130921c8c46662.png',
    link: '#',
    hoverColor: 'blue',
    description: 'Move Azure workloads, databases, and applications with confidence',
    savings: 'Migration Services',
    gradient: 'border-blue-300',
    iconColor: 'text-blue-500'
  },
  {
    id: 2,
    name: 'Google Cloud',
    logo: '../assets/images/migration/gcp-logo-abd3ce0748e83ff6e50c8074962dd13a.png',
    link: '#',
    hoverColor: 'yellow',
    description: 'Seamless migration of cloud infrastructure and critical workloads',
    savings: 'Cloud Modernization',
    gradient: 'border-yellow-300',
    iconColor: 'text-yellow-500'
  },
  {
    id: 3,
    name: 'DigitalOcean',
    logo: '../assets/images/migration/do.png',
    link: '#',
    hoverColor: 'sky',
    description: 'Modernize applications and optimize infrastructure performance',
    savings: 'Business Growth',
    gradient: 'border-sky-300',
    iconColor: 'text-sky-500'
  }
];

  // Quick links
  const quickLinks = [
    { name: 'OVH → Hetzner', href: 'https://wz-it.com/en/migration/ovh-to-hetzner/' },
    { name: 'Scaleway → Hetzner', href: 'https://wz-it.com/en/migration/scaleway-to-hetzner/' },
    { name: 'Linode → Hetzner', href: 'https://wz-it.com/en/migration/linode-to-hetzner/' },
    { name: '→ All migrations', href: 'https://wz-it.com/en/migration/', isGray: true }
  ];

  // Arrow Icon
  const ArrowIcon = ({ hoverColor }) => {
    const colorClass = hoverColor === 'blue' ? 'group-hover:text-blue-500' :
                       hoverColor === 'yellow' ? 'group-hover:text-yellow-500' :
                       'group-hover:text-sky-500';
    
    return (
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24" 
        strokeWidth="1.5" 
        stroke="currentColor" 
        className={`w-5 h-5 text-gray-300 ${colorClass} transition-colors`}
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" 
        />
      </svg>
    );
  };

  // Hetzner Logo (same for all)
  const HetznerLogo = () => (
    <div className="bg-white rounded-xl p-2 shadow-sm border border-gray-100 w-14 h-14 flex items-center justify-center">
      <img 
        src="../assets/images/migration/hetzner-logo-c38db8c1cd1f5aef63bed4374a4fbeaf.png" 
        alt="Hetzner" 
        className="max-h-10 max-w-10 object-contain"
      />
    </div>
  );

  const getBorderClass = (hoverColor) => {
    switch (hoverColor) {
      case 'blue': return 'hover:border-blue-300';
      case 'yellow': return 'hover:border-yellow-300';
      case 'sky': return 'hover:border-sky-300';
      default: return 'hover:border-gray-300';
    }
  };

  return (
    <section className="py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">
          Migrate from Leading Cloud Providers
        </h2>
        
        {/* Providers Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {providers.map((provider) => (
            <a
              key={provider.id}
              className={`group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 ${getBorderClass(provider.hoverColor)}`}
              href={provider.link}
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-white rounded-xl p-2 shadow-sm border border-gray-100 w-14 h-14 flex items-center justify-center">
                  <img 
                    src={provider.logo} 
                    alt={provider.name} 
                    className="max-h-10 max-w-10 object-contain"
                  />
                </div>
                <ArrowIcon hoverColor={provider.hoverColor} />
                <HetznerLogo />
              </div>
              
              <h3 className="font-bold text-gray-900 mb-2">
                {provider.name} to Hetzner
              </h3>
              <p className="text-gray-600 text-sm mb-3">
                {provider.description}
              </p>
              <p className="text-green-600 font-bold">
                {provider.savings}
              </p>
            </a>
          ))}
        </div>
        
        {/* Quick Links */}
        <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm">
          {quickLinks.map((link, index) => (
            <a
              key={index}
              className={`${link.isGray ? 'text-gray-600 hover:text-gray-800' : 'text-blue-600 hover:text-blue-800'} hover:underline`}
              href={link.href}
            >
              {link.name}
            </a>
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default OtherProvidersSection;